import { DescriptionsItem } from 'element-ui'

const YDescriptionsItem = DescriptionsItem
YDescriptionsItem.$depends = [DescriptionsItem]
YDescriptionsItem.$name = 'y-descriptions-item'
YDescriptionsItem._name = 'DescriptionsItem 描述选项'

export default YDescriptionsItem
